'use strict';

angular.module('amexReconciliationApp')
  .service('TransactionReceiptService',
    function TransactionReceiptService($rootScope,
                                       ActiveTransactionModel,
                                       TransactionReceiptRepository,
                                       TransactionsModel) {
      var self = this;

      self.getReceipts = TransactionReceiptRepository.findReceiptsByTransaction;

      self.unmatchReceiptFromTransaction = function (matchedReceipt, transaction) {
        return TransactionReceiptRepository
          .unmatchReceiptFromTransaction(matchedReceipt, transaction)
          .then(updateActiveTransactionModel)
          .then(function (receiptsStillMatched) {
            TransactionsModel.refreshTransactions([transaction.id]);
            return receiptsStillMatched;
          });
      };

      self.matchReceiptsToTransactions = function (receipts, transactions) {
        return TransactionReceiptRepository.matchReceiptsToTransaction(receipts, transactions).then(function () {
          TransactionsModel.refreshTransactions(_.map(transactions, 'id'));
          var existingReceipts = ActiveTransactionModel.receipts();
          if(existingReceipts) {
            ActiveTransactionModel.receipts(existingReceipts.concat(receipts));
          }else{
            ActiveTransactionModel.receipts(receipts);
          }
        });
      };
      
      function updateActiveTransactionModel(receipts) {
        ActiveTransactionModel.receipts(receipts);
        return receipts;
      }
    }
  );



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/TransactionReceiptService.js
// module id = 652
// module chunks = 0